import { getScrollEventTarget, scrollContainerMediaQuery } from '@theme/scroll-container';

class ParallaxTileBannerComponent extends HTMLElement {
  #banner;
  #background;
  #scrollTarget;
  #frame;
  #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  connectedCallback() {
    this.#banner = this.querySelector('[data-parallax-tile-banner]');
    this.#background = this.querySelector('[data-parallax-tile-banner-background]');
    if (!this.#banner || !this.#background) return;

    this.#bindScrollTarget();
    window.addEventListener('resize', this.#requestUpdate, { passive: true });
    this.#reducedMotion.addEventListener('change', this.#requestUpdate);
    scrollContainerMediaQuery.addEventListener('change', this.#handleBreakpointChange);
    this.#update();
  }

  disconnectedCallback() {
    this.#scrollTarget?.removeEventListener('scroll', this.#requestUpdate);
    window.removeEventListener('resize', this.#requestUpdate);
    this.#reducedMotion.removeEventListener('change', this.#requestUpdate);
    scrollContainerMediaQuery.removeEventListener('change', this.#handleBreakpointChange);
    if (this.#frame) cancelAnimationFrame(this.#frame);
  }

  #bindScrollTarget() {
    this.#scrollTarget?.removeEventListener('scroll', this.#requestUpdate);
    this.#scrollTarget = getScrollEventTarget();
    this.#scrollTarget.addEventListener('scroll', this.#requestUpdate, { passive: true });
  }

  #handleBreakpointChange = () => {
    this.#bindScrollTarget();
    this.#requestUpdate();
  };

  #requestUpdate = () => {
    if (!this.#frame) this.#frame = requestAnimationFrame(() => this.#update());
  };

  #update() {
    this.#frame = undefined;
    if (this.#reducedMotion.matches) {
      this.#background.style.removeProperty('--parallax-tile-banner-position-y');
      return;
    }

    const rect = this.#banner.getBoundingClientRect();
    const intensity = Number(this.#banner.dataset.parallaxSpeed || 0);
    const travel = intensity * 7;
    const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
    const offset = (progress - 0.5) * travel;

    this.#background.style.setProperty('--parallax-tile-banner-position-y', `${Math.round(offset)}px`);
  }
}

if (!customElements.get('parallax-tile-banner-component')) {
  customElements.define('parallax-tile-banner-component', ParallaxTileBannerComponent);
}
